import { CTACardProps } from '@/components/card/types';

export const getCTACard = (dict: any): CTACardProps =>
  ({
    variant: 'cta',
    title: dict?.ctaCard?.title,
    description: [
      {
        type: 'paragraph',
        children: [
          {
            text: dict?.ctaCard?.description,
            type: 'text',
          },
        ],
      },
    ],
    link: {
      rightIcon: { name: 'arrow-right' },
      href: dict?.ctaCard?.link?.href,
      target: '_self',
      variant: 'primary',
      title: dict?.ctaCard?.link?.title,
    },
    extraDescription: dict?.ctaCard?.extraDescription,
    links: [
      {
        leftIcon: { name: 'phone' },
        href: 'tel:+41 43 355 44 55',
        variant: 'tertiary',
        children: '+41 43 355 44 55',
      },
      {
        leftIcon: { name: 'mail' },
        href: 'mailto:contact@smzh.ch',
        variant: 'tertiary',
        children: 'contact@smzh.ch',
      },
    ],
    theme: 'light',
  }) as CTACardProps;
